export enum VehicleOwnership {
  OWN = 'OWN',
  LOAN = 'LOAN',
  LEASE = 'LEASE',
  COOWN = 'COOWN',
  LOANLEASE = 'LOANLEASE',
  ISBUSINESS = 'ISBUSINESS',
  NONE = 'NONE'
}
